import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { IntercomProvider } from 'react-use-intercom';
import { LicenseInfo } from '@mui/x-license';

import '../common/lib/mixpanel';

import { env } from '../common/lib/env.js';
import { mixpanelService } from '../common/lib/mixpanel';
import { initSentry, sentryRootOptions } from '../common/lib/sentry';

import './lib/analytics.js';
import './lib/logrocket.js';
import './lib/pixels.js';
import '../common/css/index.css';
import { App } from './components/App';
import { store } from './store';

initSentry(env.sentryDsnApp);

// Allowed to be exposed
// https://mui.com/x/introduction/licensing/#license-key-security
LicenseInfo.setLicenseKey(env.muiLicenceKey);

if (env.mixpanelToken) {
  console.log(`loaded`);

  mixpanelService.pageLoad();
}

if (env.isDev) {
  document.title = `${document.title} ${env.isLocal ? `local`: env.environment}`;
}

// Use test workspace in nonprod
const intercomAppId = env.isProd ? `pphwm0na` : `w3u7sxnn`;

const container = document.getElementById(`app`);
const root = createRoot(container, sentryRootOptions);

document.addEventListener(`DOMContentLoaded`, () => {
  root.render(
    <Provider store={ store }>
      <IntercomProvider appId={ intercomAppId }>
        <App />
      </IntercomProvider>
    </Provider>,
  );
});
